import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortCode'
})
export class SortCodePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let result: string;
    const s = value;
    const sortCodeLength = 6;
    if ((s || '').length === sortCodeLength) {
      result = `${s[0]}${s[1]}-${s[2]}${s[3]}-${s[4]}${s[5]}`;
    } else {
      result = s;
    }
    return result;
  }

}
